/** テナント専用パッケージの表示名（draft API に package 表示名が無い場合の fallback） */
export const DEFAULT_IN_HOUSE_PACKAGE_DISPLAY_NAME = 'テナント専用パッケージ';